import { ConvertTime } from '@/components/smartUtils/conversion/ConvertTime'
import { Text } from '@/local/components'

import { useTexts } from '../useTexts'

import { Stack } from '@mui/material'

interface Props {
  timeWindows: uui.domain.rm.TimeWindow[]
  violations?: uui.domain.rm.RouteStepViolationsType[]
}

export function OrderTimeWindow(props: Props) {
  const { timeWindows, violations } = props
  const texts = useTexts()

  const color = (violations || []).includes('TW') ? '$darkOrange' : '$nightRider'

  return (
    <Stack direction="column" marginTop={1}>
      <Text size="$s" weight="$semiBold" color="$shadyLady" uppercase>
        {texts.timeWindows}
      </Text>
      {timeWindows.map((timeWindow, index) => (
        <Text key={index} size="$m" color={color}>
          <ConvertTime seconds={timeWindow.startSec} showSeconds={false} />
          {` - `}
          <ConvertTime seconds={timeWindow.endSec} showSeconds={false} />
        </Text>
      ))}
    </Stack>
  )
}
